import { Observable } from 'rxjs';
import { streem } from 'streem-sdk-protobuf';
import { streemLogger } from '../util/streem_logger';
const DATA_MESSAGE_TOPIC = 'tool-engine-data-track';
export class ChimeLocalDataTrack {
    constructor(audioVideoFacade) {
        this.audioVideoFacade = audioVideoFacade;
        this.logger = streemLogger.extend('sdk-chime-video:ChimeLocalDataTrack');
    }
    send(message) {
        // data is a Uint8Array, which is sent by chime without extra encoding:
        // https://github.com/aws/amazon-chime-sdk-js/blob/main/src/task/SendAndReceiveDataMessagesTask.ts#L68
        const data = streem.room.DataTrackMessage.encode(message).finish();
        this.audioVideoFacade.realtimeSendDataMessage(DATA_MESSAGE_TOPIC, data);
    }
    disconnect() {
        this.logger.info('ChimeLocalDataTrack disconnecting from data messages.');
        // nothing to do
    }
}
export class ChimeRemoteDataTrack {
    constructor(audioVideoFacade) {
        this.audioVideoFacade = audioVideoFacade;
        this.logger = streemLogger.extend('sdk-chime-video:ChimeRemoteDataTrack');
        this.messages = new Observable(subscriber => {
            this.audioVideoFacade.realtimeSubscribeToReceiveDataMessage(DATA_MESSAGE_TOPIC, (dataMessage) => {
                const msg = streem.room.DataTrackMessage.decode(new Uint8Array(dataMessage.data));
                subscriber.next(msg);
            });
        });
    }
    disconnect() {
        this.logger.info('ChimeRemoteDataTrack disconnecting from data messages.');
        this.audioVideoFacade.realtimeUnsubscribeFromReceiveDataMessage(DATA_MESSAGE_TOPIC);
    }
}
//# sourceMappingURL=data_tracks.js.map